export const returnModalHTML = (openModal, navigate, isMobile) => {
  const config = openModal.config;
  return isMobile ? (
    <div className="mobile-flex">
      {config?.img}
      <div className="modal_content">
        <p className="subheading">{config?.subHeading}</p>
        <h3 className="heading">{config?.heading}</h3>
        <p className="description">{config?.desc}</p>
      </div>
      <div className="button" onClick={() => navigate(config?.continueRoute)}>
        Continue
      </div>
    </div>
  ) : (
    <div className="flex">
      <div className="modal_content">
        <p className="subheading">{config?.subHeading}</p>
        <h3 className="heading">{config?.heading}</h3>
        <p className="description">{config?.desc}</p>
        <div className="button" onClick={() => navigate(config?.continueRoute)}>
          Continue
        </div>
      </div>
      {config?.img}
    </div>
  );
};
